const styObj = {
  default: {
    '--page-color01': '#fafafa',
    '--page-color02': '#fafafa',
    '--page-color03': '#202326',
    '--page-color04': '#8e9092',
    '--page-color05': '#e3e4e5',
    '--page-color06': '#202326',
    '--page-color07': '#f0f1f2',
    '--page-color08': '#353a3f',
    '--page-color09': '#5f656a',
    '--page-color10': '#fff4d6',
    '--page-color11': '#733406',
    '--page-color12': '#ffa433',
    '--page-color13': '#202326',
    '--page-color14': '#5f656a',
    '--page-color15': '#f0f1f2',
    '--page-color16': '#e3e4e5',
    '--page-color17': '#353a3f',
    '--page-color18': '#f0f1f2',
    '--page-color19': '#f2f4f7',
    '--page-color20': '#000000',
    '--page-color21': '#f0f1f2',
    '--page-color23': '#8e9092',
    // '--page-color24': '#e3e4e5',
    '--page-color25': '#e3e4e5',
    '--page-color26': '#ffa433',
    '--page-color27': '#ffb94d',
    '--page-color28': '#fff4d6',
    '--page-color29': '#fafafa',
    '--page-color30': '#e3e4e5',
    '--page-color31': '#202326',
    '--page-color32': '#5f656a',
    '--page-color33': '#d7d7d8',
    '--page-color34': '#5f656a',
    '--page-color35': '#202326',
    '--page-color36': '#fafafa',
    '--page-color37': '#ffffff',
    '--page-color38': '#202326',
    '--page-color39': '#5f656a',
    '--page-color40': '#fff4d6',
    '--page-color41': '#202326',
    '--level-block-background': 'linear-gradient(126deg, #fffde6 -5.15%, #f1bf6e 107.49%)',
    '--van-progress__portion-background': 'linear-gradient(90deg, rgba(255, 164, 51, 0.3) 0%, var(--bg-themes-brand-regular-default, #ffa433) 100%)',
    // 图片资源
    '--icon-topbg-off': `url(${require('@/assets/packageAssets/views/P1_Boys/MyLevel/default/topbg-off.png')})`,
    '--icon-topbg-on': `url(${require('@/assets/packageAssets/views/P1_Boys/MyLevel/default/topbg-on.png')})`,
    '--icon-level-off': `url(${require('@/assets/packageAssets/views/P1_Boys/MyLevel/default/level-off.png')})`,
    '--icon-level-on': `url(${require('@/assets/packageAssets/views/P1_Boys/MyLevel/default/level-on.png')})`,
    '--icon-level0': `url(${require('@/assets/packageAssets/views/P1_Boys/MyLevel/default/lv0.png')})`,
    '--icon-level1': `url(${require('@/assets/packageAssets/views/P1_Boys/MyLevel/default/lv1.png')})`
  },
  joyu: {
    '--page-color01': '#fafafa',
    '--page-color02': '#fafafa',
    '--page-color03': '#202326',
    '--page-color04': '#8e9092',
    '--page-color05': '#e3e4e5',
    '--page-color06': '#202326',
    '--page-color07': '#f0f1f2',
    '--page-color08': '#353a3f',
    '--page-color09': '#5f656a',
    '--page-color10': '#FFECDD',
    '--page-color11': '#733406',
    '--page-color12': '#FFA433',
    '--page-color13': '#202326',
    '--page-color14': '#5f656a',
    '--page-color15': '#f0f1f2',
    '--page-color16': '#e3e4e5',
    '--page-color17': '#353a3f',
    '--page-color18': '#f0f1f2',
    '--page-color19': '#f2f4f7',
    '--page-color20': '#000000',
    '--page-color21': '#f0f1f2',
    '--page-color23': '#8e9092',
    // '--page-color24': '#e3e4e5',
    '--page-color25': '#e3e4e5',
    '--page-color26': '#FF6A55',
    '--page-color27': '#C7E77E',
    '--page-color28': '#FFECDD',
    '--page-color29': '#fafafa',
    '--page-color30': '#e3e4e5',
    '--page-color31': '#202326',
    '--page-color32': '#5f656a',
    '--page-color33': '#d7d7d8',
    '--page-color34': '#5f656a',
    '--page-color35': '#202326',
    '--page-color36': '#fafafa',
    '--page-color37': '#ffffff',
    '--page-color38': '#202326',
    '--page-color39': '#5f656a',
    '--page-color40': '#fff4d6',
    '--page-color41': '#202326',
    '--level-block-background': 'linear-gradient(126deg, #fffde6 -5.15%, #f1bf6e 107.49%)',
    '--van-progress__portion-background': 'linear-gradient(90deg, rgba(255, 164, 51, 0.3) 0%, var(--bg-themes-brand-regular-default, #ffa433) 100%)',
    // 图片资源
    '--icon-topbg-off': `url(${require('@/assets/packageAssets/views/P1_Boys/MyLevel/default/topbg-off.png')})`,
    '--icon-topbg-on': `url(${require('@/assets/packageAssets/views/P1_Boys/MyLevel/default/topbg-on.png')})`,
    '--icon-level-off': `url(${require('@/assets/packageAssets/views/P1_Boys/MyLevel/default/level-off.png')})`,
    '--icon-level-on': `url(${require('@/assets/packageAssets/views/P1_Boys/MyLevel/default/level-on.png')})`,
    '--icon-level0': `url(${require('@/assets/packageAssets/views/P1_Boys/MyLevel/whonow/lv0.png')})`,
    '--icon-level1': `url(${require('@/assets/packageAssets/views/P1_Boys/MyLevel/whonow/lv1.png')})`
  },
  vibeo: {
    '--page-color01': '#fafafa',
    '--page-color02': '#fafafa',
    '--page-color03': '#202326',
    '--page-color04': '#8e9092',
    '--page-color05': '#e3e4e5',
    '--page-color06': '#202326',
    '--page-color07': '#f0f1f2',
    '--page-color08': '#353a3f',
    '--page-color09': '#5f656a',
    '--page-color10': '#fff4d6',
    '--page-color11': '#733406',
    '--page-color12': '#ffa433',
    '--page-color13': '#202326',
    '--page-color14': '#5f656a',
    '--page-color15': '#f0f1f2',
    '--page-color16': '#e3e4e5',
    '--page-color17': '#353a3f',
    '--page-color18': '#f0f1f2',
    '--page-color19': '#f2f4f7',
    '--page-color20': '#000000',
    '--page-color21': '#f0f1f2',
    '--page-color23': '#8e9092',
    // '--page-color24': '#e3e4e5',
    '--page-color25': '#e3e4e5',
    '--page-color26': '#ffa433',
    '--page-color27': '#ffb94d',
    '--page-color28': '#fff4d6',
    '--page-color29': '#fafafa',
    '--page-color30': '#e3e4e5',
    '--page-color31': '#202326',
    '--page-color32': '#5f656a',
    '--page-color33': '#d7d7d8',
    '--page-color34': '#5f656a',
    '--page-color35': '#202326',
    '--page-color36': '#fafafa',
    '--page-color37': '#ffffff',
    '--page-color38': '#202326',
    '--page-color39': '#5f656a',
    '--page-color40': '#fff4d6',
    '--page-color41': '#202326',
    '--level-block-background': 'linear-gradient(126deg, #fffde6 -5.15%, #f1bf6e 107.49%)',
    '--van-progress__portion-background': 'linear-gradient(90deg, rgba(255, 164, 51, 0.3) 0%, var(--bg-themes-brand-regular-default, #ffa433) 100%)',
    // 图片资源
    '--icon-topbg-off': `url(${require('@/assets/packageAssets/views/P1_Boys/MyLevel/default/topbg-off.png')})`,
    '--icon-topbg-on': `url(${require('@/assets/packageAssets/views/P1_Boys/MyLevel/default/topbg-on.png')})`,
    '--icon-level-off': `url(${require('@/assets/packageAssets/views/P1_Boys/MyLevel/default/level-off.png')})`,
    '--icon-level-on': `url(${require('@/assets/packageAssets/views/P1_Boys/MyLevel/default/level-on.png')})`,
    '--icon-level0': `url(${require('@/assets/packageAssets/views/P1_Boys/MyLevel/default/lv0.png')})`,
    '--icon-level1': `url(${require('@/assets/packageAssets/views/P1_Boys/MyLevel/default/lv1.png')})`
  },
  whonow: {
    '--page-color01': '#fafafa',
    '--page-color02': '#fafafa',
    '--page-color03': '#202326',
    '--page-color04': '#8e9092',
    '--page-color05': '#e3e4e5',
    '--page-color06': '#202326',
    '--page-color07': '#f0f1f2',
    '--page-color08': '#353a3f',
    '--page-color09': '#5f656a',
    '--page-color10': '#EAF5C8',
    '--page-color11': '#102006',
    '--page-color12': '#5F656A',
    '--page-color13': '#202326',
    '--page-color14': '#5f656a',
    '--page-color15': '#f0f1f2',
    '--page-color16': '#e3e4e5',
    '--page-color17': '#353a3f',
    '--page-color18': '#f0f1f2',
    '--page-color19': '#f2f4f7',
    '--page-color20': '#000000',
    '--page-color21': '#f0f1f2',
    '--page-color23': '#8e9092',
    // '--page-color24': '#e3e4e5',
    '--page-color25': '#e3e4e5',
    '--page-color26': '#102006',
    '--page-color27': '#C7E77E',
    '--page-color28': '#C7E77E',
    '--page-color29': '#fafafa',
    '--page-color30': '#e3e4e5',
    '--page-color31': '#202326',
    '--page-color32': '#5f656a',
    '--page-color33': '#d7d7d8',
    '--page-color34': '#5f656a',
    '--page-color35': '#202326',
    '--page-color36': '#fafafa',
    '--page-color37': '#ffffff',
    '--page-color38': '#202326',
    '--page-color39': '#5f656a',
    '--page-color40': '#fff4d6',
    '--page-color41': '#202326',
    '--level-block-background': 'linear-gradient(126deg, #fffde6 -5.15%, #f1bf6e 107.49%)',
    '--van-progress__portion-background': 'linear-gradient(90deg, rgba(255, 164, 51, 0.3) 0%, var(--bg-themes-brand-regular-default, #ffa433) 100%)',
    // 图片资源
    '--icon-topbg-off': `url(${require('@/assets/packageAssets/views/P1_Boys/MyLevel/default/topbg-off.png')})`,
    '--icon-topbg-on': `url(${require('@/assets/packageAssets/views/P1_Boys/MyLevel/default/topbg-on.png')})`,
    '--icon-level-off': `url(${require('@/assets/packageAssets/views/P1_Boys/MyLevel/default/level-off.png')})`,
    '--icon-level-on': `url(${require('@/assets/packageAssets/views/P1_Boys/MyLevel/default/level-on.png')})`,
    '--icon-level0': `url(${require('@/assets/packageAssets/views/P1_Boys/MyLevel/whonow/lv0.png')})`,
    '--icon-level1': `url(${require('@/assets/packageAssets/views/P1_Boys/MyLevel/whonow/lv1.png')})`
  }
}

export const pageCssVars = {
  methods: {
    cssVars() {
      if (this.packageName) {
        // 有配置
        if (styObj[this.packageName]) {
          return styObj[this.packageName]
        }
        // 未配置
        else {
          return styObj['default']
        }
      }
      return {}
    }
  }
}
